import { Landing } from './components/Landing';
import { MonitorPage } from './components/MonitorPage';
import { MonitorTablePage } from './components/MonitorTablePage';
import { TablePage } from './components/TablePage';
import { navigate, useRoute } from './router';

export function App() {
  const route = useRoute();
  if (route.page === 'table') return <TablePage roomId={route.roomId} />;
  if (route.page === 'monitor') return <MonitorPage path={route.path} />;
  if (route.page === 'monitorTable') return <MonitorTablePage path={route.path} roomId={route.roomId} />;
  return <Landing onCreated={roomId => navigate(`/r/${roomId}`)} />;
}
